import { render, staticRenderFns } from "./image-with-text-col-1.vue?vue&type=template&id=02bd309e&scoped=true&"
import script from "./image-with-text-col-1.vue?vue&type=script&lang=js&"
export * from "./image-with-text-col-1.vue?vue&type=script&lang=js&"
import style0 from "./image-with-text-col-1.vue?vue&type=style&index=0&id=02bd309e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bd309e",
  null
  
)

export default component.exports